import React from "react";
import PreviewSliderSection from "./PreviewSliderSection";
import "./style.scss";
const LandingPage = () => {
    return (React.createElement("div", { className: "landing-page-container landing-page-container--viewport-fill" },
        React.createElement("div", { className: "landing-page-grid" },
            React.createElement("div", { className: "landing-card landing-card--preview-slider" },
                React.createElement(PreviewSliderSection, null)))));
};
export default LandingPage;
